import { Input } from "@heroui/react";
import { SearchIcon } from "@/components/icons/SearchIcon";

export default function NameFilter({
  selected,
  setSelected,
  placeholder,
  className = "",
  id = "search-filter",
  rounded = "",
}: {
  selected: string;
  setSelected: any;
  placeholder: string;
  className?: string;
  id?: string;
  rounded?: string;
}) {
  return (
    <div>
      <Input
        id={id}
        size="lg"
        radius="sm"
        className={`w-[200px] ` + className}
        classNames={{
          input: ["text-sm"],
          inputWrapper: ["min-h-0", "h-[32px]", rounded],
        }}
        isClearable
        placeholder={placeholder}
        startContent={<SearchIcon />}
        value={selected}
        onValueChange={setSelected}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            const activeElement = document?.activeElement as HTMLElement | null;
            activeElement?.blur();
          }
        }}
      />
      {/* <p className="text-default-500 text-small">Input value: {selected}</p> */}
    </div>
  );
}
